const styles = {
  app: {
    background: '#E5E5E5',
  },
};

export default styles;
